import React from "react";
import momentTimezone from "moment-timezone";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketActions from "../actions/EventBucketActions";
import EventBucketStore from "../stores/EventBucketStore";

import WorkingIndicator from "./partials/working-indicator.jsx";

class NewEventBucket extends React.Component {
  constructor(props) {
    super(props);
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  static getStores() {
    return [EventBucketStore];
  }

  static getPropsFromStores() {
    return {
      newEventBucketId: EventBucketStore.getState().newEventBucketId
    };
  }

  componentWillMount() {
    if (
      this.props.location.query.force ||
      window.confirm("Are you sure you'd like to create a new event bucket?")
    ) {
      EventBucketActions.create({
        name: "Unnamed Event Bucket",
        timezone: momentTimezone.tz.guess()
      });
    } else {
      this.context.router.goBack();
    }
  }

  componentWillReceiveProps(props) {
    if (props.newEventBucketId) {
      this.context.router.replace(
        `/event_buckets/${props.newEventBucketId}/settings`
      );
    }
  }

  render() {
    return <WorkingIndicator fullPage={true} />;
  }
}

export default connectToStores(NewEventBucket);



// WEBPACK FOOTER //
// ./src/app/components/new-event-bucket.jsx